import { useEffect, useState } from "react"

const useIsServer = () => {
    const [isServer, setIsServer] = useState<boolean>(typeof window === 'undefined' ? true : false);

    return isServer;
}

export default useIsServer;